let day_care = `Vanhemmille voi olla vaikeaa päättää, missä hoitaa pientä lasta.
Jotkut haluavat pitää lapsensa kotona, kun taas toiset haluavat päiväkodin.
Kotona lapsi tuntee olonsa turvalliseksi ja rakastetuksi perheensä kanssa.
He voivat joustaa päivittäisessä rutiinissaan ja saada enemmän huomiota.
Mutta he saattavat jäädä pelaamatta ja ystävystyä muiden lasten kanssa.
Päiväkodit auttavat lapsia oppimaan leikkiä ja jakamaan muiden kanssa.
He noudattavat myös rutiinia, joka auttaa lapsia oppimaan ja valmistautumaan kouluun.
Jotkut vanhemmat kuitenkin pelkäävät, että heidän lapsensa sairastuu toisista lapsista.
He ovat myös huolissaan hyvän päiväkodin löytämisestä huolehtivien opettajien kanssa.
Vanhempien tulee miettiä, mikä on parasta heidän lapselleen ja perheelleen.
Molemmissa vaihtoehdoissa on hyviä ja ei niin hyviä asioita.
On tärkeää valita vaihtoehto, joka tekee lapsen onnelliseksi ja auttaa häntä kasvamaan ja oppimaan hyvin.
Keskusteleminen muiden vanhempien kanssa ja vieraileminen eri päiväkodeissa voivat auttaa tekemään oikean valinnan.
Tärkeintä on, että lapsi tuntee olonsa turvalliseksi ja onnelliseksi missä tahansa.
Muista, että jokainen lapsi on erilainen, joten mikä sopii yhdelle, ei välttämättä toimi toiselle.
Luottamus vaistoihisi vanhempana voi ohjata sinua tekemään parhaan päätöksen pikkuisellesi.`;

export default day_care;































